import { inject, Service } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { StorageService } from '@services';
import { IHttpAuthHandler } from '@data-services/http';

@Service()
export class HttpSilentAuthService extends IHttpAuthHandler {
  private readonly authService = inject(AuthService);
  private readonly storage = inject(StorageService);
  private readonly router = inject(Router);

  override async silentAuthenticate(): Promise<void> {
    const credentials = await this.storage.getUserCredentials();
    if (!credentials?.username || !credentials?.password) {
      this.handleAuthFailure();
      return;
    }
    await this.authService.signin(credentials.username, credentials.password);
  }

  override handleAuthFailure(): void {
    void this.router.navigate(['/login']);
  }
}
